// removed by extract-text-webpack-plugin
module.exports = {"nf-add-user":"nf-add-user","nf-add-user__header":"nf-add-user__header","nf-add-user__subheader":"nf-add-user__subheader","add-user-main-container":"add-user-main-container","add-user-header":"add-user-header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AddUser/AddUser.scss
// module id = 5375
// module chunks = 1